import Thumbnail from "../components/Thumbnail";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import crypto from "../assets/images/crypto.jpg";
import campground from "../assets/images/campground.jpg";
import visualizer from "../assets/images/visualizer.png";

function Projects(props) {
  return (
    <section>
      <Container>
        <h1 className="my-3">Projects</h1>
        <Row style={{ alignItems: "flex-end" }}>
          <Col>
            <Thumbnail
              title="YelpCamp"
              img={campground}
              description="YelpCamp is a website that enables users to create, update, delete, and view campgrounds from around the world."
              alt="YelpCamp Project Image"
              link="https://serene-reaches-24646.herokuapp.com/"
            />
          </Col>
          <Col>
            <Thumbnail
              title="Sorting Visualizer"
              img={visualizer}
              description="The Sorting Visualizer project enables users to view different array sorting methods in real time."
              alt="Sorting Visualizer Project Image"
              link="https://github.com/simoncarrier/sorting-visualizer"
            />
          </Col>
          <Col>
            <Thumbnail
              title="Meso Coin"
              img={crypto}
              description="Meso Coin was a exploratory project to better understand the backend of a cryptocurrency by creating my own."
              alt="Crypto Project Image"
              link="https://github.com/simoncarrier/Meso-Coin"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Projects;
